import { dcpcApi } from './dcpcApi';

const ACTUATOR_TAG = 'ACTUATOR_TAG';

dcpcApi.enhanceEndpoints({ addTagTypes: [ACTUATOR_TAG] });

const backendVersionApi = dcpcApi.injectEndpoints({
  endpoints: (builder) => ({
    getActuatorInfo: builder.query({
      query: () => '/actuator/info',
      providesTags: [ACTUATOR_TAG],
    }),
  }),
});

export const {
  useGetActuatorInfoQuery,
} = backendVersionApi;
